// Procurement regions: where a supplier is, grouped as Soechi buys. Sertica has no region field
// (`/CountryCodes` holds only a number and a name), so the dashboard keeps the grouping, keyed by
// Sertica's own country numbers, some of them not ISO (UAE, KSA, TPE, SWD, BVI, TEX, POR).

export const REGIONS = [
  "Indonesia",
  "Southeast Asia",
  "East Asia",
  "South Asia",
  "Middle East",
  "Europe",
  "Americas",
  "Africa",
  "Oceania",
] as const;
export type Region = (typeof REGIONS)[number];

/** Every country in Sertica's list on 2026-11-04 (57), by its `countryCodeNo`. */
export const COUNTRY_REGION: Record<string, Region> = {
  IDN: "Indonesia",
  SGP: "Southeast Asia", MYS: "Southeast Asia", VNM: "Southeast Asia", PHL: "Southeast Asia",
  THA: "Southeast Asia", BRN: "Southeast Asia", MMR: "Southeast Asia",
  CHN: "East Asia", KOR: "East Asia", JPN: "East Asia", HKG: "East Asia", TPE: "East Asia",
  IND: "South Asia", BGD: "South Asia", LKA: "South Asia", PAK: "South Asia",
  // Egypt and Cyprus by trade lane: Suez and East Med, bought with the Gulf.
  UAE: "Middle East", TUR: "Middle East", QAT: "Middle East", KSA: "Middle East", BHR: "Middle East",
  OMN: "Middle East", EGY: "Middle East", CYP: "Middle East",
  GBR: "Europe", NOR: "Europe", DEU: "Europe", NLD: "Europe", DNK: "Europe", GRC: "Europe",
  ITA: "Europe", ESP: "Europe", FRA: "Europe", FIN: "Europe", SWD: "Europe", BEL: "Europe",
  ROU: "Europe", POL: "Europe", CHE: "Europe", EST: "Europe", POR: "Europe", RUS: "Europe",
  USA: "Americas", TEX: "Americas", CAN: "Americas", MEX: "Americas", PAN: "Americas",
  ECU: "Americas", BVI: "Americas",
  ZAF: "Africa", MAR: "Africa", NGA: "Africa", GHA: "Africa", SYC: "Africa",
  AUS: "Oceania", MHL: "Oceania",
};

/** Null for an address with no country, or a country added in Sertica after this list. */
export const regionOf = (countryCodeNo: string | null | undefined): Region | null =>
  (countryCodeNo && COUNTRY_REGION[countryCodeNo]) || null;
